import HomeCollectionBody from './HomeCollectionBody';

export default HomeCollectionBody;
